export default "__VITE_ASSET__COEsBH2F__"